import script from "./itemDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./itemDialog.vue?vue&type=script&setup=true&lang=js"

import "./itemDialog.vue?vue&type=style&index=0&id=4e9f12ca&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9f12ca"]])

export default __exports__